module.exports = __webpack_public_path__ + "img/step-1.79bc3ca7.png";